export default "__VITE_ASSET__eXBoNvdx__"